export const packageType = {
	tv: 'телевизия',
	internet: 'интернет',
	package: 'пакет'
};

